module.exports = __webpack_public_path__ + "ma.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ma.svg
// module id = 676
// module chunks = 0